<template>
    <div>
        <div style="background-color: rgba(0, 0, 0, 0.2); position:fixed; z-index:50; left:0px; top:0px; width:100%;"
             :style="{height : 'calc(100% - 65px - ' + $GlobalStore.navigationBarHeight() + 'px)'}" v-if="isShowPopupBanner" @click="hide"></div>
        <div style="position:fixed;  z-index:50;left:0px; bottom:64px; width:100%; background-color: white; padding:15px; border-top-left-radius: 15px; border-top-right-radius: 15px;transition: transform 0.3s; transform:translateY(0%)"
             :style="{ transform: isShowPopupBanner ? 'translateY(0%)' : 'translateY(calc(100% + 65px + ' + $GlobalStore.navigationBarHeight() + 'px))', bottom: 'calc(64px + ' + $GlobalStore.navigationBarHeight() + 'px)' }">
            <div>
                <swiper ref="filterSwiper" :options="swiperOption" role="tablist" @slideChange="detectSlideChanged">
                    <swiper-slide role="tab" v-for="each, i in banners" :key="i">
                        <div style="" @click="showDetail(each.action, each.param1, each); $Util.sendEventClick('사커하우_광고팝업클릭')">
                            <div style=""><img :src="$resourcePath + each.image_path" @error="(e) => { e.target.src = require('@/assets/branch_no.png') }" style="width:100%;"></div>
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination paging_text" slot="pagination" style="width:100%; font-size:12px; display:inline-block;"></div>
                </swiper>
            </div>
            <!-- <div style="height:50px; text-align:center; line-height:50px; border:1px solid #d8ddea; margin-top:10px;" @click.stop="showDetailCur(); $Util.sendEventClick('사커하우_광고팝업_자세히보기')">자세히보기</div> -->
            <div style="display:flex;">
                <div style="padding:20px 20px 0px 0px; color:#9ea3a9;font-size:14px;" @click.stop="hideForAday(); $Util.sendEventClick('사커하우_광고팝업_하루동안_보지않기')">하루동안 보지 않기</div>
                <div style="flex:1;"></div>
                <div style="padding:20px 0px 0px 20px; color:#9ea3a9;font-size:14px;" @click.stop="hide(); $Util.sendEventClick('사커하우_광고팝업_닫기')">닫기</div>
            </div>
        </div>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { HOME_POPUP_TODAY_CLOSE_DATE } from "../../Constants";
import moment from 'moment';

export default {
    name: "PopupBanner",
    components: { swiper, swiperSlide },
    props: {
        banners: {
            type: Array,
            default: () => []
        },
        hide: {
            type: Function,
            default: () => { }
        },
        isShowPopupBanner: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 6, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                autoplay: {
                    delay: 5000
                },
                curIndex: 0,
            },
        }
    },
    methods: {
        showDetail(action, param1, bannerInfo) {
            if (bannerInfo.idx === 12) {
                this.$Util.sendEventClick('홈_만보기_배너', true)
            }
            window.pushCustomManager.goScreen('배너', param1, action, param1, '');
        },
        hideForAday() {
            localStorage.setItem(HOME_POPUP_TODAY_CLOSE_DATE, moment().format('YYYY-MM-DD'));
            this.hide();
        },
        showDetailCur() {
            let index = 0;
            if (this.curIndex !== null) {
                if (isNaN(this.curIndex)) {
                    index = 0;
                } else {
                    index = this.curIndex;
                }
            }

            const each = this.banners[index];
            window.pushCustomManager.goScreen('배너', each.branch_idx, each.action, each.param1, '');
        },
        detectSlideChanged() {
            this.curIndex = this.$refs.filterSwiper.swiper.realIndex;
        },
    },
    mounted() {
        this.curIndex = 0;
    },
}
</script>

<style scoped>
.swiper .swiper-pagination {
    position: absolute;
    bottom: 65px !important;
}

.swiper-pagination-bullet {
    background: white;
    width: 6px;
    height: 6px;
    opacity: 1;
}

.swiper-pagination-bullet-active {
    background: #7c7c7c;
}
</style>